import Box from '@pagerland/common/src/components/Box';
import Container from '@pagerland/common/src/components/Container';
import Gallery from '@pagerland/common/src/components/Gallery';
import Grid from '@pagerland/common/src/components/Grid';
import Typography from '@pagerland/common/src/components/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Fade from 'react-reveal/Fade';
import data from '../../data';
import { StyledImg } from './styled.components';





const About = ({
  name,
  title,
  text,
  posttext,
  gallery,
  WrapperProps,
  ContainerProps,
  CaptionProps,
  TitleProps,
  TextProps,
  GridProps,
  ImgProps,
}) => (
  <Box id={name} name={name} {...WrapperProps}>
    <Container {...ContainerProps}>
      <Box {...CaptionProps}>
        <Fade bottom cascade duration={600}>
          <Typography {...TitleProps}>{title}</Typography>
          <Typography {...TextProps}>{text}</Typography>
          <Typography {...TextProps}>{posttext}</Typography>
        </Fade>
        <Box>
          <Grid {...GridProps}>
            <Gallery
              images={gallery}
              renderItem={(item, i, onClick) => (
                <Fade key={i} bottom cascade duration={600} delay={i * 100}>
                  <StyledImg onClick={onClick} {...ImgProps} key={i} {...item.ImgProps} />
                </Fade>
              )}
            />
          </Grid>
        </Box>
      </Box>
    </Container>
  </Box>
);

About.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.node,
  text: PropTypes.node,
  posttext: PropTypes.node,
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string.isRequired,
      ImgProps: PropTypes.object,
    }),
  ),
  WrapperProps: PropTypes.object,
  ContainerProps: PropTypes.object,
  CaptionProps: PropTypes.object,
  TitleProps: PropTypes.object,
  TextProps: PropTypes.object,
  GridProps: PropTypes.object,
  ImgProps: PropTypes.object,
};

About.defaultProps = {
  WrapperProps: {
    bg: '#fcfaf6',
    borderTopWidth: '1px',
    borderTopColor: 'rgba(31, 35, 40, 0.08)',
    pt: {
      _: 'auto',
      md: 104,
    },
    pb: 92,
  },
  CaptionProps: {
    maxWidth: 'auto',
    mx: 'auto',
  },
  PostCaptionProps: {
    maxWidth: 'auto',
    mx: 'auto',
    py: {
      _: 'auto',
      md: 'auto',
      lg: 'auto',
    },
    pb: 80,
  },
  TitleProps: {
    accent: 'before',
    as: 'h2',
    variant: 'h2',
    mb: 3,
    color: '#1f2328',
  },
  TextProps: {
    variant: 'body2',
    mb: 36,
    color: 'rgba(31, 35, 40, 0.78)',
    lineHeight: 1.7,
  },
  GridProps: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '16px',
  },
  ImgProps: {
    display: 'block',
    width: '100%',
  },
  ...data.about,
};

export default About;
